import { PostPromotionResponse } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

/** Copy a facility's metadata rows to the promotion target. */
export const postPromotion = async (
  facilityId: number
): Promise<PostPromotionResponse> => {
  const { data } = await queryBuilder(
    'POST',
    `onboarding/promotion/${facilityId}`,
    undefined,
    {}
  );
  return data;
};
